var React = require('react');

function DashboardActive (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11 1c0-.369.296-.667.667-.667h2c.368 0 .666.298.666.666v11.334h.665a.666.666 0 1 1 0 1.334H1.002a.666.666 0 1 1 0-1.334h.665V8.998c0-.367.295-.665.666-.665h2c.369 0 .667.299.667.665v3.335h1.333V4.331c0-.367.296-.664.667-.664h2c.368 0 .667.299.667.664v8.002H11V1zM3 9.666v2.666h.667V9.667H3zM7.667 5v7.333h.666V5h-.666zm4.666-3.333v10.666H13V1.667h-.667z","fill":"#3A66E5","fillRule":"evenodd"}));
}

DashboardActive.defaultProps = {"width":"16","height":"14","viewBox":"0 0 16 14"};

module.exports = DashboardActive;

DashboardActive.default = DashboardActive;
